export default __webpack_public_path__ + "static/media/add.dc6b3f41.svg";